var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isAuthenticated)?_c('div',[_c('v-dialog',{attrs:{"width":"1000"},on:{"click:outside":_vm.hideLogin},model:{value:(_vm.showLogin),callback:function ($$v) {_vm.showLogin=$$v},expression:"showLogin"}},[_c('LoginForm')],1)],1):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }